/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Election } from '../models/election';
import { getActiveElections } from '../fn/election/get-active-elections';
import { GetActiveElections$Params } from '../fn/election/get-active-elections';

@Injectable({ providedIn: 'root' })
export class ElectionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getActiveElections()` */
  static readonly GetActiveElectionsPath = '/election/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveElections()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveElections$Response(params?: GetActiveElections$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Election>>> {
    const obs = getActiveElections(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActiveElections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveElections(params?: GetActiveElections$Params, context?: HttpContext): Observable<Array<Election>> {
    const resp = this.getActiveElections$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Election>>): Array<Election> => r.body)
    );
  }

}
